import moment from "moment";

const BOM = "﻿";
const HEADER = ["LINHA", "COLUNA", "ERRO"];

function escapeCell(value) {
  const text = value === null || value === undefined ? "" : String(value);

  return /[";\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
}

function toLine(cells) {
  return cells.map(escapeCell).join(";");
}

export function buildImportErrorReport(rows) {
  const lines = (rows || []).map((row) =>
    toLine([row.linha, row.coluna, row.mensagem]),
  );

  return {
    filename: "ERROS_IMPORTACAO_" + moment().format("YYYYMMDD_HHmmss") + ".csv",
    content: BOM + [toLine(HEADER)].concat(lines).join("\r\n") + "\r\n",
  };
}
